// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__16YCT","list":"styles_list__178xG"};